import { addDays, weekEnd } from '@painpal/core';
import { Copy } from 'lucide-react';
import { usePlan } from '../../api/queries';
import { useCopyPlanWeek } from '../../api/mutations';
import { errorMessage } from '../../lib/api';
import { copySourceLine, weekPlanTotals } from './planModel';
import styles from './calendar.module.css';

// Shown only for a week with no blocks; the API refuses (409) a week that gained one meanwhile.
// `disabled` holds the button while the shown week is still the previous week's placeholder.
export function CopyLastWeek({ week, disabled }: { week: string; disabled: boolean }) {
  const previous = addDays(week, -7);
  const last = usePlan(previous, weekEnd(previous));
  const copy = useCopyPlanWeek();
  const totals = last.data === undefined || last.isPlaceholderData ? null : weekPlanTotals(last.data.days);
  const empty = totals !== null && totals.blocks === 0;
  const failed = last.isError && totals === null;
  const source = failed ? "COULDN'T LOAD LAST WEEK" : totals === null ? '' : empty ? 'LAST WEEK HAS NOTHING PLANNED' : copySourceLine(previous, totals);
  return (
    <div className={styles.empty}>
      <div className={styles.emptyText}>
        <p className={styles.emptyTitle}>NOTHING PLANNED YET</p>
        <p className={styles.emptyBody}>Start from last week and adjust, or tap a day to add one block.</p>
      </div>
      <div className={styles.copy}>
        <button type="button" className={styles.copyButton} disabled={disabled || totals === null || empty || copy.isPending} onClick={() => copy.mutate({ from: previous, to: week })}>
          <Copy size={14} aria-hidden="true" />COPY LAST WEEK
        </button>
        <p className={styles.copySource}>{source}</p>
        {failed && <button type="button" className={styles.copyRetry} disabled={last.isFetching} onClick={() => void last.refetch()}>RETRY</button>}
        {copy.isError && <p role="alert" className="alert-hot">{errorMessage(copy.error)}</p>}
      </div>
    </div>
  );
}
